module.exports = __webpack_public_path__ + "static/media/chart2Icon.6078b424.svg";